export const distCsvFilter = (module, tab, role, tile, content) => {
  // console.log(
  //   "CSV DETAILS ARRIVING in module, tab, role, tile, content format: ",
  //   module,
  //   tab,
  //   role,
  //   tile,
  //   content
  // );
  let csv = content;
  ({
    "Device Sales": () => {
      ({
        ZD: () => {
          ({
            RDS: () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ZD Code"] = obj["zd"] ?? "";
                      obj["ZD Name"] = obj["zdName"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ZD Code"] = obj["rds"] ?? "";
                      obj["ZD Name"] = obj["rdsName"] ?? "";
                      obj["RDS Code"] = obj["retailer"] ?? "";
                      obj["RDS Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
            "Retailers Billed": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ZD Code"] = obj["zd"] ?? "";
                      obj["ZD Name"] = obj["zdName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Role"] = obj["partnerRoleType"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ZD Code"] = obj["zd"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                },
              })[tile]();
              return csv;
            },
            "Preferred Retailer": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ZD Code"] = obj["zd"] ?? "";
                      obj["ZD Name"] = obj["zdName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Role"] = obj["partnerRoleType"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ZD Code"] = obj["zd"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                },
              })[tile]();
              return csv;
            },
          })[tab]();
          return csv;
        },
        RDS: () => {
          ({
            "Retailers Billed": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
            "Preferred Retailer": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
          })[tab]();
          return csv;
        },
        ARD: () => {
          ({
            "Retailers Billed": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["UAO Code"] = obj["retailer"] ?? "";
                      obj["UAO Name"] = obj["retailerName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ARD Code"] = obj["rds"] ?? "";
                      obj["UAO Code"] = obj["retailer"] ?? "";
                      obj["UAO Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
            "Unique Recharge outlet (URO)": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["URO Code"] = obj["retailer"] ?? "";
                      obj["URO Name"] = obj["retailerName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ARD Code"] = obj["rds"] ?? "";
                      obj["URO Code"] = obj["retailer"] ?? "";
                      obj["URO Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
          })[tab]();
          return csv;
        },
        MARD: () => {
          ({
            "Retailers Billed": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["UAO Code"] = obj["retailer"] ?? "";
                      obj["UAO Name"] = obj["retailerName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["MARD Code"] = obj["rds"] ?? "";
                      obj["UAO Code"] = obj["retailer"] ?? "";
                      obj["UAO Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
            URO: () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["URO Code"] = obj["retailer"] ?? "";
                      obj["URO Name"] = obj["retailerName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["MARD Code"] = obj["rds"] ?? "";
                      obj["URO Code"] = obj["retailer"] ?? "";
                      obj["URO Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
          })[tab]();
          return csv;
        },
        ITZ: () => {
          ({
            ITD: () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["IT ZD Code"] = obj["zd"] ?? "";
                      obj["IT ZD Name"] = obj["zdName"] ?? "";
                      obj["ITD Code"] = obj["rds"] ?? "";
                      obj["ITD Name"] = obj["rdsName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["IT ZD Code"] = obj["rds"] ?? "";
                      obj["IT ZD Name"] = obj["rdsName"] ?? "";
                      obj["ITD Code"] = obj["retailer"] ?? "";
                      obj["ITD Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
            "Retailers Billed": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["IT ZD Code"] = obj["zd"] ?? "";
                      obj["IT ZD Name"] = obj["zdName"] ?? "";
                      obj["ITD Code"] = obj["rds"] ?? "";
                      obj["ITD Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["IT ZD Code"] = obj["zd"] ?? "";
                      obj["IT ZD Name"] = obj["zdName"] ?? "";
                      obj["ITD Code"] = obj["rds"] ?? "";
                      obj["ITD Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
          })[tab]();
          return csv;
        },
        ITD: () => {
          ({
            "Retailers Billed": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["IT ZD Code"] = obj["zd"] ?? "";
                      obj["IT ZD Name"] = obj["zdName"] ?? "";
                      obj["ITD Code"] = obj["rds"] ?? "";
                      obj["ITD Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["IT ZD Code"] = obj["zd"] ?? "";
                      obj["IT ZD Name"] = obj["zdName"] ?? "";
                      obj["ITD Code"] = obj["rds"] ?? "";
                      obj["ITD Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
            },
          })[tab]();
        },
        ZDMT: () => {
          ({
            Chain: () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ZDMT Code"] = obj["zd"] ?? "";
                      obj["ZDMT Name"] = obj["zdName"] ?? "";
                      obj["CHAIN Code"] = obj["rds"] ?? "";
                      obj["CHAIN Name"] = obj["rdsName"] ?? "";
                      obj["Role"] = obj["partnerRoleType"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ZDMT Code"] = obj["zd"] ?? "";
                      obj["ZDMT Name"] = obj["zdName"] ?? "";
                      obj["CHAIN Code"] = obj["rds"] ?? "";
                      obj["CHAIN Name"] = obj["rdsName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
            "Stores Billed": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ZDMT Code"] = obj["zd"] ?? "";
                      obj["ZDMT Name"] = obj["zdName"] ?? "";
                      obj["CHAIN Code"] = obj["rds"] ?? "";
                      obj["CHAIN Name"] = obj["rdsName"] ?? "";
                      obj["Store Code"] = obj["retailer"] ?? "";
                      obj["Store Name"] = obj["retailerName"] ?? "";
                      obj["Role"] = obj["partnerRoleType"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["ZDMT Code"] = obj["zd"] ?? "";
                      obj["ZDMT Name"] = obj["zdName"] ?? "";
                      obj["CHAIN Code"] = obj["rds"] ?? "";
                      obj["CHAIN Name"] = obj["rdsName"] ?? "";
                      obj["STORE Code"] = obj["retailer"] ?? "";
                      obj["STORE Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                },
              })[tile]();
              return csv;
            },
          })[tab]();
        },
        CHAIN: () => {
          ({
            "Stores Billed": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["Chain Code"] = obj["rds"] ?? "";
                      obj["Chain Name"] = obj["rdsName"] ?? "";
                      obj["Store Code"] = obj["retailer"] ?? "";
                      obj["Store Name"] = obj["retailerName"] ?? "";
                      obj["Role"] = obj["partnerRoleType"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["Chain Code"] = obj["rds"] ?? "";
                      obj["Chain Name"] = obj["rdsName"] ?? "";
                      obj["Store Code"] = obj["retailer"] ?? "";
                      obj["Store Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
          })[tab]();
          return csv;
        },
        RZD: () => {
          ({
            "Direct Rural Store": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["RZD Code"] = obj["zd"] ?? "";
                      obj["RZD Name"] = obj["zdName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["RZD Code"] = obj["rds"] ?? "";
                      obj["RZD Name"] = obj["rdsName"] ?? "";
                      obj["DRS Code"] = obj["retailer"] ?? "";
                      obj["DRS Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
          })[tab]();
          return csv;
        },
        JC: () => {
          ({
            "Retailers Billed": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["Retailer"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";

                      obj["JIO_POINT_ID"] = obj["jioPointId"] ?? "";
                      obj["JIO_POINT_NAME"] = obj["jioPointName"] ?? "";
                      obj["JPR_TYPE_NAME"] = obj["jprTypeName"] ?? "";

                      delete obj["jcName"];
                      delete obj["jioCenter"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["jprTypeName"];
                      delete obj["lmtdBilled"];
                      delete obj["mtdBilled"];
                      delete obj["partnerRoleType"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["region"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["state"];
                      delete obj["status"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["Retailer"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC_Code"] = obj["jioCenter"] ?? "";
                      obj["JC_Name"] = obj["jcName"] ?? "";
                      obj["JIO_POINT_ID"] = obj["jioPointId"] ?? "";
                      obj["JIO_POINT_NAME"] = obj["jioPointName"] ?? "";
                      obj["JPR_Type_Name"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";

                      delete obj["jcName"];
                      delete obj["jioCenter"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["jprTypeName"];
                      delete obj["lmtdBilled"];
                      delete obj["mtdBilled"];
                      delete obj["partnerRoleType"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["region"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["state"];
                      delete obj["status"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      return obj;
                    });
                },
              })[tile]();
              return csv;
            },
            "Preferred Retailer": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
          })[tab]();
          return csv;
        },
        JP: () => {
          ({
            "Retailers Billed": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["Retailer"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";

                      obj["JIO_POINT_ID"] = obj["jioPointId"] ?? "";
                      obj["JIO_POINT_NAME"] = obj["jioPointName"] ?? "";
                      obj["JPR_TYPE_NAME"] = obj["jprTypeName"] ?? "";

                      delete obj["jcName"];
                      delete obj["jioCenter"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["jprTypeName"];
                      delete obj["lmtdBilled"];
                      delete obj["mtdBilled"];
                      delete obj["partnerRoleType"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["region"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["state"];
                      delete obj["status"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["Retailer"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC_Code"] = obj["jioCenter"] ?? "";
                      obj["JC_Name"] = obj["jcName"] ?? "";
                      obj["JIO_POINT_ID"] = obj["jioPointId"] ?? "";
                      obj["JIO_POINT_NAME"] = obj["jioPointName"] ?? "";
                      obj["JPR_Type_Name"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";

                      delete obj["jcName"];
                      delete obj["jioCenter"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["jprTypeName"];
                      delete obj["lmtdBilled"];
                      delete obj["mtdBilled"];
                      delete obj["partnerRoleType"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["region"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["state"];
                      delete obj["status"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      return obj;
                    });
                },
              })[tile]();
              return csv;
            },
            "Preferred Retailer": () => {
              ({
                billed: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jprTypeName"];
                      delete obj["partnerRoleType"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["status"];
                      delete obj["mtdUao"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      return obj;
                    });
                  return csv;
                },
                onboard: () => {
                  csv =
                    content &&
                    content.map((obj) => {
                      obj["Region"] = obj["region"] ?? "";
                      obj["State"] = obj["state"] ?? "";
                      obj["RDS Code"] = obj["rds"] ?? "";
                      obj["RDS Name"] = obj["rdsName"] ?? "";
                      obj["Retailer Code"] = obj["retailer"] ?? "";
                      obj["Retailer Name"] = obj["retailerName"] ?? "";
                      obj["JC Code"] = obj["jioCenter"] ?? "";
                      obj["JC Name"] = obj["jcName"] ?? "";
                      obj["JPR Type"] = obj["jprTypeName"] ?? "";
                      obj["Status"] = obj["status"] ?? "";
                      obj["MTD_Billed"] = obj["mtdBilled"] ?? "";
                      obj["LMTD_Billed"] = obj["lmtdBilled"] ?? "";
                      delete obj["region"];
                      delete obj["state"];
                      delete obj["zd"];
                      delete obj["zdName"];
                      delete obj["rds"];
                      delete obj["rdsName"];
                      delete obj["retailer"];
                      delete obj["retailerName"];
                      delete obj["jioCenter"];
                      delete obj["jcName"];
                      delete obj["jprTypeName"];
                      delete obj["status"];
                      delete obj["mtdBilled"];
                      delete obj["lmtdBilled"];
                      delete obj["jioPointId"];
                      delete obj["jioPointName"];
                      delete obj["partnerRoleType"];
                      return obj;
                    });
                  return csv;
                },
              })[tile]();
              return csv;
            },
          })[tab]();
          return csv;
        },
      })[role]();
      return csv;
    },
  })[module]();
  return csv;
};
